import React, { PureComponent } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import Responsive from 'react-responsive'

import styles from './Layout.scss'

export default class Layout extends PureComponent {
  render() {
    const {
      children,
      className,
      width,
      height,
      minWidth,
      minHeight,
      flex,
      style,
      onClick,
      visibleDefault,
      visibleHandheld,
      visibleDesktop,
      visibleMobile,
      visibleTablet,
      visibleLarge,
      ...rest
    } = this.props

    const classNameObject = {}
    let breakpoints = null

    Object.keys(rest).forEach(classNameKey => {
      classNameObject[styles[classNameKey]] = rest[classNameKey]
    })

    const classes = cx(styles.root, {
      ...classNameObject,
      [styles.clickable]: onClick,
      [className]: className
    })

    let styleObject = {
      ...style,
      height,
      width,
      minHeight
    }

    if (flex) {
      styleObject.flex = flex
    }

    const Component = (
      <div className={classes} style={styleObject} onClick={onClick} ref={this.ref}>
        {children}
      </div>
    )

    if (visibleLarge) {
      breakpoints = { minWidth: 1170, maxWidth: null }
    }

    if (visibleDefault) {
      breakpoints = { minWidth: 768, maxWidth: null }
    }

    if (visibleHandheld) {
      breakpoints = { minWidth: null, maxWidth: 991 }
    }

    if (visibleDesktop) {
      breakpoints = { minWidth: 992, maxWidth: null }
    }

    if (visibleMobile) {
      breakpoints = { minWidth: null, maxWidth: 767 }
    }

    if (visibleTablet) {
      breakpoints = { minWidth: 768, maxWidth: 991 }
    }

    return breakpoints ? <Responsive {...breakpoints}>{Component}</Responsive> : Component
  }
}

Layout.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,

  horizontal: PropTypes.bool,
  vertical: PropTypes.bool,
  mobileVertical: PropTypes.bool,
  tabletVertical: PropTypes.bool,
  mobileHorizontal: PropTypes.bool,
  wrap: PropTypes.bool,

  flex: PropTypes.number,

  fullWidth: PropTypes.bool,
  fullHeight: PropTypes.bool,

  padding: PropTypes.bool,
  paddingHalf: PropTypes.bool,
  paddingVertical: PropTypes.bool,
  paddingVerticalHalf: PropTypes.bool,
  paddingHorizontal: PropTypes.bool,
  paddingHorizontalHalf: PropTypes.bool,
  paddingLeft: PropTypes.bool,
  paddingLeftHalf: PropTypes.bool,
  paddingRight: PropTypes.bool,
  paddingRightHalf: PropTypes.bool,
  paddingBottom: PropTypes.bool,
  paddingBottomHalf: PropTypes.bool,
  paddingBottomQuarter: PropTypes.bool,
  paddingTop: PropTypes.bool,
  paddingTopHalf: PropTypes.bool,

  margin: PropTypes.bool,
  marginVertical: PropTypes.bool,
  marginVerticalHalf: PropTypes.bool,
  marginHorizontal: PropTypes.bool,
  marginHorizontalHalf: PropTypes.bool,
  marginTop: PropTypes.bool,
  marginTopHalf: PropTypes.bool,
  marginBottom: PropTypes.bool,
  marginBottomHalf: PropTypes.bool,
  marginLeft: PropTypes.bool,
  marginLeftHalf: PropTypes.bool,
  marginRight: PropTypes.bool,
  marginRightHalf: PropTypes.bool,
  marginRightQuarter: PropTypes.bool,
  marginVerticalLarge: PropTypes.bool,

  spaceBetween: PropTypes.bool,
  spaceAround: PropTypes.bool,
  justifyEnd: PropTypes.bool,
  justifyCenter: PropTypes.bool,
  justifyStart: PropTypes.bool,
  alignCenter: PropTypes.bool,
  alignEnd: PropTypes.bool,
  alignStart: PropTypes.bool,

  textLeft: PropTypes.bool,
  textRight: PropTypes.bool,
  textCenter: PropTypes.bool,

  red: PropTypes.bool,
  blue: PropTypes.bool,
  blueDark: PropTypes.bool,
  blueLight: PropTypes.bool, // TODO: Try to have just one of the light blues (light blue).
  blueExtraLight: PropTypes.bool,
  white: PropTypes.bool,
  grey: PropTypes.bool,
  gray: PropTypes.bool,

  border: PropTypes.bool,
  outline: PropTypes.bool,
  borderBottom: PropTypes.bool,
  borderBlue: PropTypes.bool,
  borderBlueTopBold: PropTypes.bool,

  visibleDefault: PropTypes.bool,
  visibleHandheld: PropTypes.bool,
  visibleDesktop: PropTypes.bool,
  visibleTablet: PropTypes.bool,
  visibleMobile: PropTypes.bool,

  borderTop: PropTypes.bool
}
